export enum EFormMode {
  VIEW = 'view',
  NEW = 'new',
  EDIT = 'edit',
  CLONE = 'clone',
}
